import React, { useEffect, useState, useMemo } from 'react';
import { Modal, CloseButton, Button } from 'react-bootstrap';
import Required from '../../../Required';
import searchIcon from '../../../../../img/finder.svg';
import style from './TabResults.module.less';

export default function ImpactProjectsModal({show, onHide, onSave, value, projects, isForResult}){
  const [inputValue, setInputValue] = useState('');
  const [respOptions, setRespOptions] = useState([]);
  const [selected, setSelected] = useState([]);

    useEffect(() => {
    setRespOptions(
      projects.map((project) => ({
        label: `${project.fullNumber} ${project.name}`,
        value: project,
      })),
    );
  }, [projects]);

    const options = useMemo(
		() => [
			...selected,
			...respOptions.filter(opt =>
				!selected.some(
					selectedOpt => selectedOpt.value.originId === opt.value.originId
				)
			),
		],
		[respOptions, selected]
	)   

  useEffect(() => {
    setSelected(value.projs.reduce((acc, curr) => {
      const selectedOpt = respOptions.find(opt => opt.value.originId === curr.originId)
      return selectedOpt ? [...acc, {...selectedOpt, selected: !!curr.selected}] : acc
    }, []));
    // setSelected(respOptions.filter(opt => value.projs.some(proj => proj.originId === opt.value.originId)) || []);
  }, [show, respOptions]);


  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header>
        <Modal.Title>
          Проекты, влияющие на выполнение {isForResult ? 'результата' : 'вехи'}
          {' '}
          <Required />
        </Modal.Title>
        <CloseButton className="ms-auto" onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <div className={style['modal-search']}>
          <img src={searchIcon} className={style['modal-searchIcon']} />
          <input
            className={style['modal-input']}
            placeholder="№ и название проекта"
            onChange={(event) => setInputValue(event.target.value)}
            value={inputValue}
          />
          <button
            className="btn-close ms-auto"
            onClick={() => setInputValue('')}
          />
        </div>
        <ul className={style['modal-options']}>
          {options.sort((a, b) => a.value.fullNumber.length - b.value.fullNumber.length || +a.value.fullNumber - +b.value.fullNumber).filter(opt => opt.label.toLowerCase().includes(inputValue.toLowerCase())).map((opt) => (
            <li
              className={style['modal-option']}
              style={{backgroundColor: selected.some(selectedOpt => selectedOpt.value.originId === opt.value.originId) ? '#DCE7FF' : '#fff'}}
              key={`proj-${opt.value.originId}`}
              onClick={() =>
							  setSelected((prevState) =>
							    (prevState.some(selectedOpt => selectedOpt.value.originId === opt.value.originId) ?
                   [...prevState.filter(selectedOpt => selectedOpt.value.originId !== opt.value.originId)] :
                   [...prevState, {...opt, value: {...opt.value, selected: true}}]))}
            >
              <input
                type="checkbox"
                checked={!!selected.some(selectedOpt => selectedOpt.value.originId === opt.value.originId)}
              />
              <p>{opt.label}</p>
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>Отмена</Button>
        <Button onClick={() => {
          onSave(selected.map(opt => ({...opt.value, id: opt.value.originId})));
          onHide();
        }}
        >
          Сохранить
        </Button>
      </Modal.Footer>
    </Modal>
  )
}